import React from 'react';
import ToTranscriptContentWrapper from './ToTranscriptContentWrapper';
import BeginCodingOnboardingWrapper from './BeginCodingOnboardingWrapper';
import codebookImage from 'images/onboarding/onboarding_codebook.png';

const CodeBookContainerContentWrapper = ({ hasCodes, children, hasEditPermission, onboardingState, projectID }) => {
    const {
        hasNoCodeableData
    } = onboardingState || {};

    const header = hasEditPermission ? "Code details in one glance, designed to help you spot patterns." : "This project is currently empty";
    const body = hasEditPermission ? "Explore your data—view your codebook or zoom into codes to see descriptions and snippets linked to transcripts." : "You're in view-only mode. As your team adds codes and transcripts, they will appear here.";
    const mediaType = "image";
    const mediaSrc = codebookImage;

    if (!!hasNoCodeableData && !hasCodes) {
        return (
            <ToTranscriptContentWrapper
                loaded={onboardingState.loaded}
                showOnboarding={hasNoCodeableData}
                header={header}
                body={body}
                mediaType="image"
                mediaSrc={codebookImage}
                hasEditPermission={hasEditPermission}
                projectID={projectID}
            >
                {children}
            </ToTranscriptContentWrapper>
        )
    }

    return <BeginCodingOnboardingWrapper
        loaded={onboardingState.loaded}
        showOnboarding={!hasCodes}
        header={header}
        body={body}
        mediaType={mediaType}
        mediaSrc={mediaSrc}
        hasEditPermission={hasEditPermission}
        projectID={projectID}
    >
        {children}
    </BeginCodingOnboardingWrapper>
}

export default CodeBookContainerContentWrapper;
